"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumableType = void 0;
var ConsumableType;
(function (ConsumableType) {
    ConsumableType["LURE"] = "LURE";
    ConsumableType["LINER"] = "LINER";
    ConsumableType["COROPLAST"] = "COROPLAST";
    ConsumableType["BATTERY"] = "BATTERY";
})(ConsumableType || (exports.ConsumableType = ConsumableType = {}));
//# sourceMappingURL=node-consumables.js.map